module.exports = __webpack_public_path__ + "static/media/full_screen.442e2328.svg";